import React from "react";

export default function EmployeePhoto({ form }) {
  const imgUrl = React.useMemo(() => {
    // 1️⃣ If user selected a new photo file, show it immediately
    if (form.photo instanceof File) {
      return URL.createObjectURL(form.photo);
    }

    // 2️⃣ If editing an existing employee and photo path exists, show saved photo
    if (form.employeephotopath) {
      // Use employeeid for fallback / cache busting
      // return `http://localhost:5000/${form.employeephotopath}?t=${form.updated_at || Date.now()}`;
      return `/${form.employeephotopath}?t=${form.updated_at || Date.now()}`;
    }

    // 3️⃣ Fallback placeholder for new employee or missing photo
    return "https://via.placeholder.com/180x240";
  }, [form.photo, form.employeephotopath, form.updated_at]);

  return (
    <img
      src={imgUrl}
      alt="Employee"
      onError={(e) => {
        // If the image fails, fallback to placeholder
        e.target.onerror = null;
        e.target.src = "https://via.placeholder.com/180x240";
      }}
      style={{
        width: 180,
        height: 240,
        objectFit: "cover",
        borderRadius: 8,
        border: "1px solid #ccc",
        marginBottom: 16,
      }}
    />
  );
}
